import { Injectable } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation';
import { Network } from '@ionic-native/network';
import { Device } from '@ionic-native/device';
import { Storage } from '@ionic/storage';
import { AlertController, ToastController, Platform, App, Events } from 'ionic-angular';
import { Http } from '@angular/http';
import 'rxjs/add/operator/catch';

@Injectable()
export class DevicesProvider {

  databaseName = '';
  conexao = true;
  public dadosDevice = <any>{};

  constructor(public app: App,
    public device: Device,
    private storage: Storage,
    private geolocation: Geolocation,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private platform: Platform,
    public http: Http,
    public events: Events,
    private network: Network) {
  }

  salvarDatabase(db, codEntregador, filial) {
    this.storage.set('databaseName', db);
    this.http.get(this.getURLEnvia() + 'inserirDevice.php?bd=' + db +
      '&codEntregador=' + codEntregador +
      '&numFilial=' + filial +
      '&uuid=' + this.getDeviceID() +
      '&serial=' + this.device.serial +
      '&plataforma=' + this.device.platform +
      '&versaoos=' + this.device.version +
      '&marca=' + this.device.manufacturer +
      '&modelo=' + this.device.model +
      '&versaoApp=' + this.getVersionNumber())
      .subscribe(res => this.platform.exitApp());
  }

  verificarConexaoInternet() {
    //verifica quando está sem conexão com a internet
    let disconnectSubscription = this.network.onDisconnect().subscribe(() => {
      this.conexao = false;

      let toast = this.toastCtrl.create({
        message: 'Sem conexão com a internet',
        duration: 3000
      });

      toast.present();
    });

    //verifica quando tem conexão com a internet
    let connectSubscription = this.network.onConnect().subscribe(() => {
      this.conexao = true;
    });
  }

  atualizarLocalizacao() {
    this.storage.get('databaseName').then((val) => {
      this.databaseName = val;
      //localização foreground
      let watch = this.geolocation.watchPosition();
      watch.subscribe((data) => {
        //atualiza localização do vendedor no firebase
        if (this.conexao) {
          this.http.get(this.getURLEnvia() + 'atualizarLocalizacaoDevice.php?bd=' + this.databaseName +
            '&uuid=' + this.getDeviceID() +
            '&latitude=' + data.coords.latitude +
            '&longitude=' + data.coords.longitude)
            .subscribe(res => console.log('OK LOCALIZAÇÃO'));
        }
      });
    });
  }

  atualizarDevice(fcmRegistrationId) {
    this.storage.get('databaseName').then((val) => {
      this.databaseName = val;
      let url = this.getURLEnvia() + 'atualizarDevice.php?bd=' + this.databaseName +
        '&uuid=' + this.getDeviceID() +
        '&serial=' + this.device.serial +
        '&plataforma=' + this.device.platform +
        '&versaoos=' + this.device.version +
        '&marca=' + this.device.manufacturer +
        '&modelo=' + this.device.model +
        '&versaoApp=' + this.getVersionNumber() +
        '&fcmRegistrationId=' + fcmRegistrationId;

      console.log(url);
      this.http.get(url).subscribe(res => console.log('OK ATUALIZA DEVICE'));
    });
  }

  getDeviceID() {
    //app
    if (this.device.uuid) {
      return this.device.uuid;
    } else {  //web-view
      return '1';
    }
  }

  getCodEntregador() {
    return this.dadosDevice.Ent_Codigo;
  }

  getCodRotaPadrao() {
    return this.dadosDevice.Rot_Codigo;
  }

  getCodFilial() {
    let codFilial = 1;

    //se existe a variável codigo filial
    if (this.dadosDevice.Emp_Numero) {
      codFilial = this.dadosDevice.Emp_Numero;
    }
    return codFilial;
  }

  getDadosDevice() {
    return new Promise((resolve, reject) => {
      this.http.get(this.getURL() + 'retornaDevice.php?bd=' + this.databaseName + '&uuid=' + this.getDeviceID())
        .map(res => res.json())
        .subscribe(data => {
          if (data.length > 0) {
            this.dadosDevice = data[0];
            this.storage.set('arrayDevice', data);
          }

          if (data.length == 0) {
            this.storage.remove('dadosDevice');
            reject(false);
          } else if (data.length > 1) {
            this.storage.get('dadosDevice').then((val) => {
              if (val) {
                this.dadosDevice = val;
                this.events.publish('device:load', this.dadosDevice.Dev_RealizaPedido == 'S');
                resolve(true);
              }
            });
          } else {
            this.storage.set('dadosDevice', this.dadosDevice);
            this.events.publish('device:load', this.dadosDevice.Dev_RealizaPedido == 'S');
          }
          resolve(true);
        },
          err => {

            this.storage.get('dadosDevice').then((val) => {
              console.log(val);
              if (val) {
                this.dadosDevice = val;
                this.events.publish('device:load', this.dadosDevice.Dev_RealizaPedido == 'S');
                resolve(true);
              } else {
                reject(false);
              }
            });
          });
    });
  }

  verificarDeviceCadastrado() {
    return new Promise((resolve, reject) => {
      this.storage.get('databaseName').then((val) => {
        this.databaseName = val;

        if ((this.databaseName == '') || (this.databaseName == null)) {
          resolve(false);
        } else {
          this.getDadosDevice().then((result) => {
            //atualiza localização do dispositivo
            this.atualizarLocalizacao();
            resolve(true);
          })
            .catch((error) => {
              let alert = this.alertCtrl.create({
                title: 'Dispositivo não ativado.',
                subTitle: 'Informe a ID do dispositivo: ' + this.getDeviceID(),
                buttons: [{
                  text: 'OK',
                  handler: data => {
                    reject(false);
                    this.platform.exitApp();
                  }
                }]
              });
              alert.present();
            });
        }
      });
    });
  }

  isConectado() {
    return this.conexao;
  }

  getVersionNumber() {
    return '2.4.2';
  }

  getURLNFCe() {

    return 'http://50.114.32.141:9120/api/atecdelivery/nfce';
    //return 'http://192.168.1.7:9120/api/atecdelivery/nfce';
  }

  getURL() {
    return 'http://50.114.32.141/atecdelivery/retorna/';
  }

  getURLEnvia() {
    return 'http://50.114.32.141/atecdelivery/recebe/';
  }

  montaURL(pagina) {
    return this.getURL() + 'retorna' + pagina + '.php?bd=' + this.databaseName + '&empNumero=' + this.getCodFilial();
  }

  montaURLEnvia(pagina) {
    return this.getURLEnvia() + 'sincroniza' + pagina + '.php?bd=' + this.databaseName + '&empNumero=' + this.getCodFilial();
  }

  verificarAtualizacao() {
    return new Promise((resolve, reject) => {
      let versaoInstalada = this.getVersionNumber();
      if (this.isConectado()) {
        this.http.get('http://www.atecsystem.masterdaweb.net:8080/verificaVersao.php?codigo=19')
          .subscribe(data => {
            resolve(versaoInstalada != data.text());
          },
            err => {
              resolve(false);
            });
      } else {
        resolve(false);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/devices/devices.ts